module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": '/clients/create'
    }
  }, [_vm._v("Create new application")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))]), _vm._v(" applications")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.clients.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No applications found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clients), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/clients/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43636744"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/ClientList.vue
// module id = 205
// module chunks = 1